export const MAP_SETTINGS_SETTINGS_UPDATE_SETTINGS = 'MAP_SETTINGS_SETTINGS/UPDATE_SETTINGS';
export const MAP_SETTINGS_ENABLE_CLICKABLE_ICONS = 'MAP_SETTINGS_ENABLE_CLICKABLE_ICONS';
export const MAP_SETTINGS_DISABLE_CLICKABLE_ICONS = 'MAP_SETTINGS_DISABLE_CLICKABLE_ICONS';
